import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, select, takeEvery, call } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { alert } from "../../../../Utils/toast";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { queryClient } from "../../../store";
import { checkLoginActions } from "../../auth/checkLogin";

export type UserLogoutLoadAction = {
  type: string;
  payload: {
    router: any;
    checkLogin?: boolean;
    dispatchCloseModal?: () => void;
  };
};

export type UserLogoutData = {
  data: {
    message: string;
  };
};

const UserLogout = new ReduxFetchState<
  UserLogoutData | null,
  { router: any; dispatchCloseModal?: () => void; checkLogin?: boolean },
  any
>("userLogout");

export function* watchUserLogout(action: UserLogoutLoadAction) {
  const { router, dispatchCloseModal, checkLogin } = action.payload;
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: UserLogoutData = yield axios({
      url: "/api/v1/users/logout",
      method: "GET",
      headers: { lang },
    });

    queryClient.clear();

    alert({ message: data?.data?.message, type: "success" });
    yield put(UserLogout.actions.loadSuccess({ data: data.data }));

    if (typeof dispatchCloseModal === "function") {
      yield call(dispatchCloseModal);
    }
    if (checkLogin) {
      yield put(checkLoginActions.load());
    }

    window.open("https://lamtakam.com", "_self");
  } catch (e: any) {
    yield put(UserLogout.actions.loadFailure(e?.response?.data));
  }
}

export function* userLogoutSagas() {
  yield takeEvery(UserLogout.actionTypes.load, watchUserLogout);
}

export function useUserLogout() {
  const { loading, data, ...userLogoutState } = useAppSelector((state) => state.userLogout);
  const dispatch = useAppDispatch();

  const dispatchUserLogout = useCallback(
    (router: any, dispatchCloseModal?: () => void, checkLogin?: boolean) => {
      dispatch(UserLogout.actions.load({ router, dispatchCloseModal, checkLogin }));
    },
    [dispatch],
  );

  return {
    ...userLogoutState,
    dispatchUserLogout,
    userLogoutLoading: loading,
    userLogoutData: data,
  };
}

export const {
  actionTypes: userLogoutActionsTypes,
  actions: userLogoutActions,
  reducer: userLogoutReducer,
} = UserLogout;
